import React from 'react';
import '../../i18n';
import { useTranslation } from 'react-i18next';

const BlogRollTile = (props: any) => {
	const { blogroll, showExcerpt, showButton, termMap, showByline } = props;
	const { t } = useTranslation();
	const terms = [blogroll.post_type, ...blogroll.terms];
	const style = {
		backgroundImage: 'url(' + blogroll.thumbnail + ')',
	};
	const buttonText = blogroll.button_text || t('Read More');

	return (
		<div
			className={
				'blogroll-results__item blogroll-results__item--' +
				blogroll.post_type
			}
		>
			{blogroll.thumbnail && (
				<img
					src={blogroll.thumbnail}
					alt={blogroll.post_title}
					className="blogroll-results__poster"
				/>
			)}
			<div className="blogroll-results__item__content">
				<div className="blogroll-results__taxonomy">
					{terms.map((term_id) => {
						const term = termMap ? termMap[term_id] : null;
						return term ? ( term.name !== 'Page' &&
							<a key={term_id} href={term.permalink}>
								{term.name}
							</a>
						) : null;
					})}
				</div>

				<h3 className="blogroll-results__heading">
					<a href={blogroll.permalink}>
						{blogroll.post_title}
					</a>
				</h3>

				{ showByline &&
				<div className="blogroll-results__metadata">
					{ blogroll.byline?.author &&
					<div className="blogroll-results__author">
						{ blogroll.byline.author_link
							? <React.Fragment>
								{t('by')} <a href={blogroll.byline.author_link}>{blogroll.byline.author}</a>
							</React.Fragment>
							: <React.Fragment>
								{t('by')} {blogroll.byline.author}
							</React.Fragment>
						}
					</div>
					}
					{ blogroll.byline?.reading_time &&
					<div className="blogroll-results__read-time">
						{blogroll.byline.reading_time}
					</div>
					}
				</div>
				}

				{showExcerpt && blogroll.post_excerpt ? (
					<div className="blogroll-results__excerpt">
						{blogroll.post_excerpt}
					</div>
				) : null}

				{blogroll.extra_content && (
					<div
						dangerouslySetInnerHTML={{
							__html: blogroll.extra_content,
						}}
					/>
				)}

				{showButton && (
					<a
						href={blogroll.permalink}
						className="btn btn-primary stretched-link"
					>
						{buttonText}
					</a>
				)}
			</div>
		</div>
	);
};

export default BlogRollTile;
